export const getS3AssetPath = (assetFilename: string) =>
  `${process.env.SHARED_ASSETS_BASE_URL}/${assetFilename}`;
